import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    handleContainer: index => ({
      marginTop: -2,
      width: 44,
      alignItems: index == 0 ? 'flex-end' : 'flex-start',
    }),
    handleView: index => ({
      height: 32,
      width: 32,
      borderRadius: 16,
      borderWidth: 2,
      backgroundColor: colors.surface,
      borderColor: colors.surface,
      left: index == 0 ? -12 : 0,
    }),
    priceText: index => ({
      left: index == 0 ? -12 : 0,
    }),
  });

export default makeStyles;
